import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import { DropdownButtonText, SelectionHighlightedText } from '../styles';

export const ColorVariantsButtonLabel = () => {
  const { t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const filter = getFilter(FilterType.VARIANT_COLOR);
  const selection = filter?.active ? filter?.selection : null;
  const selectedVariants =
    (selection?.length && selection.sort().join(', ')) ??
    t('product', 'variants.all');

  return (
    <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>
        {t('product', 'label.color')}:{' '}
        <SelectionHighlightedText>{selectedVariants}</SelectionHighlightedText>
      </TitleSmallText>
    </DropdownButtonText>
  );
};
